import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Meteor } from 'meteor/meteor';
import { isEmpty, filter, includes, get } from 'lodash';
import { Bert } from 'meteor/themeteorchef:bert';

import handleErrorInClient from '../../../modules/handle-error-in-client';
import methodPromise from '../../../modules/method-promise-wrapper';
import * as atlasOps from '../../../api/Atlas/atlas-operations';
import DebugTasksUtility from '../../components/DebugTasksUtility';
import TaskList from '../../pages/TaskList';

const { isBeta } = Meteor.settings.public;

const PER_PAGE = 5;

class TaskMonitorContainer extends Component {
  state = {
    currentPage: 1,
    searchValue: '',
    networkError: false,
    loading: true,
    taskList: []
  };

  updateInterval = null;

  debugComponent = React.createRef();

  async componentDidMount() {
    await this.updateTaskMonitor();
    this.updateInterval = setInterval(this.updateTaskMonitor, 500);
  }

  componentWillUnmount() {
    clearInterval(this.updateInterval);
  }

  updateTaskMonitor = async () => {
    const { atlasId, isAtlas, gmsConnection } = this.props;
    try {
      let debugIP = '';
      if (isBeta) {
        debugIP = get(this, 'debugComponent.current.serverIP', '2.136.192.212:30015');
      }

      const getTaskMonitorParams = { debugIP };
      if (isAtlas) {
        getTaskMonitorParams.debugIP = isEmpty(gmsConnection)
          ? ''
          : atlasOps.getGMSDirection(gmsConnection);
        getTaskMonitorParams.authenticate = false;
        getTaskMonitorParams.isTasker = false;
        getTaskMonitorParams.itemForOwner = { id: atlasId, collectionName: 'atlas' };
      }

      const validatedTasks = await methodPromise('tasks.getTaskMonitor', getTaskMonitorParams);
      this.setState({ taskList: validatedTasks, loading: false });
    } catch (error) {
      handleErrorInClient(error);
      clearInterval(this.updateInterval);
      this.setState({ networkError: true });
    }
  };

  handleSearch = event => {
    event.persist();
    if (!isEmpty(event.target.value.trim())) {
      this.setState({ searchValue: event.target.value.trim(), currentPage: 1 });
    } else {
      this.setState({ searchValue: '', currentPage: 1 });
    }
  };

  changePage = pageNumber => {
    this.setState({ currentPage: pageNumber });
  };

  getResults = async () => {
    try {
      let debugIP = '';
      if (isBeta) {
        debugIP = get(this, 'debugComponent.current.serverIP', '');
      }
      const resultingMapServerElements = await methodPromise('tasks.getTaskResults', debugIP);
      if (isEmpty(resultingMapServerElements)) {
        Bert.alert('No Layer Server To Be Created', 'warning');
      } else {
        Bert.alert('Layer Servers Created', 'success');
      }
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  filterList = () => {
    const { isAtlas, itemsPerPage, taskLabel } = this.props;
    const { taskList, currentPage, searchValue } = this.state;
    let searchList = filter(taskList, task => includes(task.label, searchValue));
    if (isAtlas)
      searchList = filter(
        taskList,
        task => task.label === taskLabel && includes(task.name, searchValue)
      );
    const filteredCount = taskList.length - searchList.length;

    const skip = currentPage * itemsPerPage - itemsPerPage;
    const totalCount = searchList.length;
    const filteredList = filter(
      searchList,
      (task, index) => index >= skip && index < skip + itemsPerPage
    );

    return { totalCount, filteredList, filteredCount };
  };

  render() {
    const {
      isAtlas,
      isFocusTrainAtlas,
      isPreview,
      isPublic,
      itemsPerPage,
      pathToConnector,
      selectTask
    } = this.props;
    const { loading, currentPage, networkError } = this.state;

    const { totalCount, filteredList, filteredCount } = this.filterList();

    return (
      <>
        {!isAtlas && <DebugTasksUtility stateRef={this.debugComponent} isMonitor />}
        <TaskList
          currentPage={currentPage}
          filteredCount={filteredCount}
          isAtlas={isAtlas}
          isFocusTrainAtlas={isFocusTrainAtlas}
          isMonitor
          isPreview={isPreview}
          isPublic={isPublic}
          itemsPerPage={itemsPerPage}
          loading={loading}
          networkError={networkError}
          pathToConnector={pathToConnector}
          taskList={filteredList}
          totalCount={totalCount}
          changePage={this.changePage}
          getResults={this.getResults}
          handleSearch={this.handleSearch}
          selectTask={selectTask}
        />
      </>
    );
  }
}

TaskMonitorContainer.defaultProps = {
  atlasId: '',
  gmsConnection: {},
  isAtlas: false,
  isFocusTrainAtlas: false,
  isPreview: false,
  isPublic: false,
  itemsPerPage: PER_PAGE,
  pathToConnector: '',
  taskLabel: '',
  selectTask: () => false
};

TaskMonitorContainer.propTypes = {
  atlasId: PropTypes.string,
  gmsConnection: PropTypes.object,
  isAtlas: PropTypes.bool,
  isFocusTrainAtlas: PropTypes.bool,
  isPreview: PropTypes.bool,
  isPublic: PropTypes.bool,
  itemsPerPage: PropTypes.number,
  pathToConnector: PropTypes.string,
  taskLabel: PropTypes.string,
  selectTask: PropTypes.func
};

export default TaskMonitorContainer;
